export const membersNumber = 100;
export const officesNumber = 4;
